import { CustomAxiosHeaders } from '../config/services'
import config from '../config'
import { requests } from '.'

// use serviceName value below as key in `versions` object in `src/config/services.ts` for developer versions
const serviceName = 'PaymentServices'
const host = config.paymentsApiURL
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}


interface RetrieveStripeAccount {
  accountId?: string
  liveMode: boolean
  locationId?: string
}

interface StripeConnect {
  locationId: string
}
interface StripeDisconnect extends StripeConnect {
  defaultPaymentProvider?: string
}

export interface CreateInvoice {
  items:string
  contactId:string
  expirationDate:string
  invoiceNumber:string
  locationId:string
  liveMode:boolean
}

export interface AccountsDetailsByLocation {
  location: string
}

export interface PaypalConnectOptions {
  locationId: string
  liveMode: boolean
  redirectURL: string
}

export interface GetPaypalAccounts {
  locationId: string
  liveMode: boolean
}

export interface PaypalConnectWithKeyOptions {
  locationId: string
  liveMode: boolean
  merchantClientId: string
  merchantSecretId: string
}

export interface BaseAction {
  locationId: string
  liveMode: boolean
}

export interface AuthorizeNetConnect extends BaseAction {
  merchantLoginKey: string
  merchantTransactionKey: string
  merchantClientKey: string
  merchantSignatureKey: string
}

export interface NMIConnect extends BaseAction {
  merchantGatewayId: string
  merchantSecurityKey: string
  merchantPublicKey: string
}

export interface UpdateDefaultPaymentProvider {
  altType: string
  altId: string
  provider: string
}

interface GetInvoiceSettings {
  altId: string
  altType: string
}

const PaymentServices = {
  connectPaypal: (params:PaypalConnectOptions) =>
    request().get('/payments/paypal/connect', { params }),
  connectPaypalWithKey: (params:PaypalConnectWithKeyOptions) =>
    request().post('/payments/paypal/connect', params),
  connectPaypalCallback: (params) =>
    request().post('/payments/paypal/callback', params),
  disconnectPaypal: (params:GetPaypalAccounts) =>
    request().post(`/payments/paypal/disconnect`, params),
  connectStripe: (params: StripeConnect) =>
    request().get('/payments/stripe/connect', { params }),
  disconnectStripe: (params: StripeDisconnect) =>
    request().post(`/payments/stripe/disconnect`, params),
  retrieveStripeAccount: (params: RetrieveStripeAccount) =>
    request().get('/payments/stripe/retrieveAccount', { params }),
  findStripeIntegration: (locationId:string) =>
    request().get(`/payments/integrations/stripe/`,{
      params:{
        location_id: locationId
      }
    }),
  createInvoice: (params:CreateInvoice) =>
    request().post('/payments/stripe/create_invoice', params),
  getIntegrations: (locationId: string) =>
    request().get(`/payments/integrations/${locationId}`),
  getIntegrationsDetails: (locationId: string) =>
    request().get(`/payments/integrations/details/${locationId}`),
  updateStripeAccountSettings: (locationId: string, enablePaymentElement: boolean) =>
    request().post(`/payments/stripe/update`, { locationId, enablePaymentElement }),
  getSubscription: ({ id, ...params }) =>
    request({ host: config.paymentServiceBaseUrl }).get(`/v1/stripe/subscription/${id}`, { params }),
  text2PayInvoice: (params:CreateInvoice) =>
    request().post('/invoices/text2pay', params),
  disableNMILabs: (locationId: string) =>
    request().post(`/payments/nmi/disable-labs`, { locationId }),
  getInvoiceSettings: (params:GetInvoiceSettings) =>
    request().post('/invoices/settings', params),
  disconnectShopify: (locationId) => 
    request().delete(`/store/shopify/${locationId}`),
}

export default PaymentServices
